import styled from 'styled-components';
import { useMemo } from 'react';
import {AnimatePresence, motion} from 'framer-motion';
import {BREAKPOINTS, THEME_MODES} from '@repo/ui/themeSettings';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedItem, setSelectedSubItem } from '@/state/menuSlice';
import { useRouter } from 'next/router';
import { AllIconsInRow } from "@repo/ui/SVGR";
import { CURSOR_TYPES } from "@repo/utils/constants";
import {revealAnimationContainer, useMenuColor} from "@repo/ui";
import {getCssSizeValue} from "@repo/utils";

const StyledWrapper = styled.div`
    @media (min-width: ${({ theme }) => theme?.breakpoints?.desktop || 1024}px) and (orientation: landscape) {
        display: flex;
		justify-content: space-between;
		position: relative;
	}
`;

const StyledLeftColumn = styled.div`
`;

const Icon = styled(motion.div)`
    height: 100%;
    width: ${getCssSizeValue(30, BREAKPOINTS.DESKTOP)};
    position: absolute;
    left: calc(${getCssSizeValue(63)} * -1);
    transform-origin: center center;
`

const StyledCircleWrapper = styled(motion.div)`
	width: 30px;
	height: 30px;
	position: absolute;
	top: 40%;
	border-radius: 50%;
	border: 1px solid ${({ theme }) => (theme.mode === THEME_MODES.DARK ? theme.colors.white : theme.colors.twilightBlue)};
	overflow: hidden;
`;

const StyledActiveIcon = styled(motion.div)`
	position: absolute;
	top: 20%;
	right: 0;
	height: 20px;
	width: 150px;
`;

const Option = styled(revealAnimationContainer('span', 'menu-item-reveal-up'))`
	cursor: pointer;
	@media (min-width: ${({ theme }) => theme.breakpoints.desktop}px) {
		font-size: ${getCssSizeValue(90, BREAKPOINTS.DESKTOP)};
		letter-spacing: -3.6px;
		display: block;
		transition: color var(--color-transition-duration) var(--ease) transform 0.3s;
		position: relative;
		width: fit-content;
        
        &.italic {
            font-weight: 300;
            font-style: italic;
        }
	}
`;

const SINGLE_WAVE_WIDTH = 30;

const MenuItem = ({ item, index, activeItem, setActiveItem, isChildIconVisible, italicItem, setItalicItem }) => {
    const dispatch = useDispatch();
    const { selectedItem } = useSelector((state) => state.menu);
    const router = useRouter();
    const text = item?.link?.menuContext?.previewText || ''
    const slug = item?.link?.slug || '';
    const longIconColor = useMenuColor()

    const initialX = useMemo(() => activeItem * SINGLE_WAVE_WIDTH, [activeItem])

    const onClick = () => {
        setItalicItem(item)
        dispatch(setSelectedSubItem(null))
        router.push(`/${slug}`);
    };

    return (
        <StyledWrapper>
            <StyledLeftColumn>
                <div className='active-item-menu-indicator' style={{ opacity: 0 }}>
                    <AnimatePresence>
                        {isChildIconVisible &&
                            <Icon initial={{ scale: 0 }} animate={{ scale: 1}} exit={{ scale: 0}} transition={{ duration: 0.2 }}>
                                {selectedItem === item && (
                                    <StyledCircleWrapper layoutId="hovered">
                                        <StyledActiveIcon
                                            initial={{ x: initialX }}
                                            animate={{
                                                x: activeItem * SINGLE_WAVE_WIDTH,
                                            }}
                                            transition={{
                                                duration: 0.6,
                                            }}
                                        >
                                            <AllIconsInRow color={longIconColor}/>
                                        </StyledActiveIcon>
                                    </StyledCircleWrapper>
                                )}
                            </Icon>
                        }
                    </AnimatePresence>
                </div>

                <Option
                    className={`underline-animation-lowercase menu-item-reveal-up ${italicItem === item  ? 'italic active' : ''}`}
                    data-cursor={CURSOR_TYPES.LINK_LOWERCASE}
                    onClick={onClick}
                    onMouseEnter={() => {
                        if (selectedItem === item) return
                        dispatch(setSelectedItem(item));
                        setActiveItem(index)
                    }}
                >
                    {text}
                </Option>
            </StyledLeftColumn>
        </StyledWrapper>
    );
};

export default MenuItem;
